// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * @hidden
 * Utility function to get currentTime in UTC milliseconds.
 * @returns
 */

export function getCurrentTimestampInMs(): number {
  return Date.now();
}
